"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Sounds {
    /**
     * @function decision Do decision type of sound
     * @Return {status} void
     */
    decision() {
        ToyotaSoundBeep.sound('decision');
    }
    /**
     * @function failure Do failure type of sound
     * @Return {status} void
     */
    failure() {
        ToyotaSoundBeep.sound('failure');
    }
    /**
     * @function notice Do notice type of sound
     * @Return {status} void
     */
    notice() {
        ToyotaSoundBeep.sound('notice');
    }
}
exports.default = Sounds;
//# sourceMappingURL=Sounds.js.map